import PropTypes from "prop-types";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./RichTextEditorField.css";

const editorModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const editorFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "link",
];

const RichTextEditorField = ({
  label,
  altLabel,
  value,
  onChange,
  minHeight = 360,
}) => {
  return (
    <div className="form-control max-w-4xl my-4">
      <div className="label">
        <span className="label-text text-base-content pr-2">{label}</span>
        {altLabel && <span className="label-text-alt">{altLabel}</span>}
      </div>
      <div
        className="bg-base-100 rounded-lg border border-base-content/20 rich-text-editor"
        style={{ "--editor-min-height": `${minHeight}px` }}
      >
        <ReactQuill
          theme="snow"
          value={value}
          onChange={onChange}
          modules={editorModules}
          formats={editorFormats}
        />
      </div>
    </div>
  );
};

RichTextEditorField.propTypes = {
  label: PropTypes.string.isRequired,
  altLabel: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  minHeight: PropTypes.number,
};

export default RichTextEditorField;
